import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyQuickViewComponent } from './lazy-quick-view/lazy-quick-view.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'quickView',
        location: () => import('../store/quick-view-store.module').then(m => m.QuickViewStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyQuickViewComponent],
  exports: [LazyQuickViewComponent],
})
export class QuickViewExportsModule {}
